import type { ReactNode } from 'react'

import { cn } from '@gto/ui/cn'

import { MODAL_ROW_DEFAULTS, type ModalRowLayout } from './modal-block-types'

type ModalRowBlockProps = ModalRowLayout & {
  children: readonly ReactNode[]
}

const GAP_CLASS = { small: 'gap-2', medium: 'gap-4', large: 'gap-8 sm:gap-4' }
// Stretch the top-aligned column wrappers to preserve existing equal-height cards.
const VERTICAL_CLASS = { top: 'items-stretch', center: 'items-center', bottom: 'items-end' }
const HORIZONTAL_CLASS = { left: 'justify-start', center: 'justify-center', right: 'justify-end' }

export const ModalRowBlock = ({
  children,
  layout = MODAL_ROW_DEFAULTS.layout,
  gap = MODAL_ROW_DEFAULTS.gap,
  vertical_align = MODAL_ROW_DEFAULTS.vertical_align,
  horizontal_align = MODAL_ROW_DEFAULTS.horizontal_align,
  mobile_layout = MODAL_ROW_DEFAULTS.mobile_layout,
  mobile_align = MODAL_ROW_DEFAULTS.mobile_align,
}: ModalRowBlockProps) => (
  <div
    data-tst="announcement-modal-row"
    className={cn(
      'flex w-full flex-row',
      GAP_CLASS[gap],
      VERTICAL_CLASS[vertical_align],
      layout === 'compact' && HORIZONTAL_CLASS[horizontal_align],
      mobile_layout === 'stack' && 'sm:flex-col sm:items-stretch',
      mobile_layout === 'inline' && 'sm:flex-wrap',
      mobile_align === 'center' && 'sm:justify-center',
    )}
  >
    {children.map((child, index) => (
      <div
        // eslint-disable-next-line @eslint-react/no-array-index-key -- ordered API columns have no stable id
        key={index}
        data-tst="announcement-modal-row-column"
        className={cn(
          'min-w-0',
          layout === 'compact' ? 'max-w-full flex-initial' : 'flex-1',
          mobile_layout === 'stack' && 'sm:w-full sm:flex-auto',
          child === null && (layout === 'compact' ? 'hidden' : 'sm:hidden'),
        )}
      >
        {child}
      </div>
    ))}
  </div>
)
